import React from 'react';
import { InstagramIcon, FacebookIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy text-white pt-16 pb-8" data-id="element-12">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-13">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12 text-center md:text-left" data-id="element-14">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-15">
            <h3 className="text-2xl font-heading font-bold italic uppercase text-white mb-4" data-id="element-16">
              Phoenix Tile & Carpet Cleaning
            </h3>
            <p className="text-white/70 mb-6 max-w-xs" data-id="element-17">
              Professional residential and commercial floor cleaning services
              across the East Valley.
            </p>
            <div className="flex gap-4" data-id="element-18">
              <a href="#" className="text-white/70 hover:text-red transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label="Instagram" data-id="element-19">
                <InstagramIcon size={24} data-id="element-20" />
              </a>
              <a href="#" className="text-white/70 hover:text-red transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label="Facebook" data-id="element-21">
                <FacebookIcon size={24} data-id="element-22" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start" data-id="element-23">
            <h4 className="text-lg font-heading font-bold italic uppercase text-white mb-4 tracking-wider" data-id="element-24">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3" data-id="element-25">
              <a href="#" className="text-white/70 hover:text-red transition-colors min-h-[44px] md:min-h-0 flex items-center" data-id="element-26">
                Home
              </a>
              <a href="#services" className="text-white/70 hover:text-red transition-colors min-h-[44px] md:min-h-0 flex items-center" data-id="element-27">
                Services
              </a>
              <a href="#areas" className="text-white/70 hover:text-red transition-colors min-h-[44px] md:min-h-0 flex items-center" data-id="element-28">
                Service Areas
              </a>
              <a href="#reviews" className="text-white/70 hover:text-red transition-colors min-h-[44px] md:min-h-0 flex items-center" data-id="element-29">
                Reviews
              </a>
              <a href="#gallery" className="text-white/70 hover:text-red transition-colors min-h-[44px] md:min-h-0 flex items-center" data-id="element-30">
                Before & After
              </a>
            </nav>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start" data-id="element-31">
            <h4 className="text-lg font-heading font-bold italic uppercase text-white mb-4 tracking-wider" data-id="element-32">
              Contact
            </h4>
            <a href="tel:6029351141" className="text-2xl font-bold text-red hover:text-red-hover transition-colors mb-4 block min-h-[44px] flex items-center" data-id="element-33">
              (602) 935-1141
            </a>
            <a href="#contact" className="text-white/70 hover:text-red transition-colors min-h-[44px] flex items-center" data-id="element-34">
              Book Online
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/50 text-center md:text-left" data-id="element-35">
          <p data-id="element-36">© 2025 Phoenix Tile & Carpet Cleaning. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-4 md:gap-6" data-id="element-37">
            <a href="#" className="hover:text-white transition-colors" data-id="element-38">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-39">
              Accessibility
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-40">
              Cancellation Policy
            </a>
          </div>
          <p data-id="element-41">
            Website by{' '}
            <a href="#" className="text-white/70 hover:text-white transition-colors" data-id="element-42">
              LetLois
            </a>
          </p>
        </div>
      </div>
    </footer>;
}